import { useState, useEffect } from 'react'
import { safeExternalHref } from '../security.js'
import { track } from '../analytics.js'

const STORAGE_KEY   = 'flow_vpn_dismissed'
const AFFILIATE_URL = safeExternalHref(import.meta.env.VITE_VPN_AFFILIATE_URL || '')
const BRAND         = import.meta.env.VITE_VPN_BRAND || 'NordVPN'

export default function VpnBanner({ bgMode = 'dark' }) {
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) === '1') setDismissed(true)
    } catch {}
  }, [])

  if (!AFFILIATE_URL || dismissed) return null

  const dismiss = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDismissed(true)
    try { localStorage.setItem(STORAGE_KEY, '1') } catch {}
  }

  const handleClick = () => {
    track('vpn_banner_clicked', { brand: BRAND })
  }

  const dark = bgMode === 'dark'

  return (
    <div style={{ position: 'relative' }}>
      <a
        href={AFFILIATE_URL}
        target="_blank"
        rel="sponsored noopener noreferrer"
        onClick={handleClick}
        style={{
          display: 'block', position: 'relative',
          background: dark
            ? 'linear-gradient(135deg, rgba(34,197,94,0.10), rgba(20,80,40,0.18))'
            : 'linear-gradient(135deg, rgba(34,197,94,0.12), rgba(20,120,60,0.08))',
          border: dark
            ? '1px solid rgba(34,197,94,0.22)'
            : '1px solid rgba(22,163,74,0.35)',
          borderRadius: 14, padding: '14px 44px 14px 16px',
          textDecoration: 'none',
          color: dark ? '#c8e6cb' : '#14532d',
          backdropFilter: 'blur(8px)',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 36, height: 36, flexShrink: 0,
            borderRadius: 10,
            background: dark ? 'rgba(34,197,94,0.18)' : 'rgba(22,163,74,0.14)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 18,
          }}>🌍</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{
              fontSize: 13, fontWeight: 700, marginBottom: 2,
              color: dark ? '#e8f5ea' : '#14532d',
            }}>
              Title not in your region? Try a VPN.
            </div>
            <div style={{
              fontSize: 11, lineHeight: 1.45,
              color: dark ? 'rgba(140,200,150,0.75)' : 'rgba(20,80,40,0.7)',
            }}>
              Unlock other countries' Netflix, Prime &amp; more with {BRAND}.
            </div>
          </div>
          <div style={{
            fontSize: 10, fontWeight: 700,
            color: dark ? '#86efac' : '#15803d',
            background: dark ? 'rgba(34,197,94,0.12)' : 'rgba(22,163,74,0.12)',
            border: dark ? '1px solid rgba(34,197,94,0.25)' : '1px solid rgba(22,163,74,0.35)',
            padding: '5px 9px', borderRadius: 7,
            letterSpacing: '0.04em', whiteSpace: 'nowrap',
          }}>TRY</div>
        </div>

        <button
          onClick={dismiss}
          aria-label="Dismiss"
          style={{
            position: 'absolute', top: 6, right: 6,
            background: 'transparent', border: 'none',
            color: dark ? 'rgba(140,200,150,0.5)' : 'rgba(20,80,40,0.4)',
            cursor: 'pointer', fontSize: 18, lineHeight: 1,
            width: 28, height: 28, borderRadius: 6,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontFamily: 'inherit',
            WebkitTapHighlightColor: 'transparent',
          }}
        >×</button>
      </a>

      {/* Compliance disclosure */}
      <div style={{
        fontSize: 9, lineHeight: 1.4,
        color: dark ? 'rgba(140,200,150,0.35)' : 'rgba(20,80,40,0.35)',
        marginTop: 5, paddingLeft: 4,
        letterSpacing: '0.02em',
      }}>
        * Sponsored link. Flow may earn a commission if you subscribe — at no extra cost to you.
      </div>
    </div>
  )
}
